import firebase from "firebase/app";
import router from "@/router";

declare const window: any;

const state = {
    course: null
};

const actions = {

    async retrieveCoursesAction({ commit }) {
        
        console.log('retrieving courses');
        if(window.gapi) {
            console.log('getting them');
            await window.gapi.client.classroom.courses.list({ pageSize: 10 })
                .then(function(response: any) {
                    const courses = response.result.courses;
                    console.log(courses);
                    commit("setCourses", courses);
                });
        }
    },

    async retrieveMathClassworkAction({ commit }) {

        console.log('retrieving math classwork');
        if(window.gapi) {
            console.log('getting math');
            await window.gapi.client.classroom.courses.courseWork.list({courseId: '123180706118'})
                .then(function(response:any) {
                    console.log('got here');
                    const classwork = response.result.courseWork;
                    console.log(classwork);
                    commit("setMathClasswork", classwork);
                });
        }
    },

    async retrieveAttendanceClassworkAction({ commit }) {

        console.log('retrieving Attendance classwork');
        if(window.gapi) {
            console.log('getting attendance');
            await window.gapi.client.classroom.courses.courseWork.list({courseId: '123180706079'})
                .then(function(response:any) {
                    console.log('got here');
                    const classwork = response.result.courseWork;
                    console.log(classwork);
                    commit("setAttendanceClasswork", classwork);
                });
        }
    }
};


const getters = {

    getCourses(state) {
        return state.courses;
    },

    getMathClasswork(state){
        return state.mathclasswork;
    },

    getAttendanceClasswork(state){
        return state.attendanceclasswork;
    }
};

const mutations = {

    setCourses(state, payload) {
        state.courses = payload;
    },

    setMathClasswork(state, payload) {
        state.mathclasswork = payload;
    },

    setAttendanceClasswork(state, payload) {
        state.attendanceclasswork = payload;
    }

};

export default {
    state,
    actions,
    getters,
    mutations
}